import { createContext } from 'react';

import { MouseInteractionContextType } from './types';

const MouseInteractionContext = createContext<MouseInteractionContextType>({ usingMouse: false });

export default MouseInteractionContext;
